// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"914ac34b","934":"5ca9a562"}[chunkId] + ".chunk.js";
};